// InvalidCharacterValidationMixin.js
// Used on the application form and the change password form

import FormHelpers from '@assets/js/form-helpers.js';

export const invalidCharacterValidationMixin = {
  data() {
    return {
      invalidCharsInEmail: null,
      invalidCharsInPassword: null,
    }
  },

  computed: {
    hasInvalidCharsInEmail() {
      return this.invalidCharsInEmail && this.invalidCharsInEmail.length;
    }
  },

  methods: {
    validateInvalidCharacters(field) {
      if (!field.hasAttribute('validate-invalid-chars')) {
        return true;
      }

      const invalidChars = FormHelpers.getInvalidDiSyCharsInString(field.value);

      // Update state
      if (field.name == 'email') {
        this.invalidCharsInEmail = invalidChars;
      }
      if (field.name == 'password') {
        this.invalidCharsInPassword = invalidChars;
      }

      if (invalidChars) {
        FormHelpers.showInvalidCharsError(field, invalidChars);
        return false;
      } else {
        FormHelpers.clearFieldError(field);
        return true;
      }
    }
  }
}

export default invalidCharacterValidationMixin;
